<template>
  <div id="glossary">
    <h1>このサイトについて</h1>

    <h2>サイトの目的</h2>
    <span class="md-body-2">日本におけるSet Danceの普及、日本語での情報提供を目的としています。
    国内におけるSet Danceにかかわる情報はダンスという特性上、個人では得難いものです。
    教本も英語のものがほとんどで初学者に優しくありません。
    実際に踊った経験を踏まえながら、こうした情報を集約していくことで、日本国内におけるセットダンス文化の成熟に寄与したいです。
    </span>

    <h2>オフラインでの使用</h2>
    <span class="md-body-2">一度ページを開くとオフライン下でもアクセスが可能です。</span>

    <h2>情報源</h2>
    <span class="md-body-2">DanceMinder, Irish Set Dancing, 日本のCCEクラスなど</span>

    <h2>制作情報</h2>
    <span class="md-body-2">vue.js + firebase</span>

    <h2>アイルランド各州の紋章について</h2>
    <span class="md-body-2">「List of Irish counties' coats of arms」 from Wikipedia CC BY-SA 3.0</span>

    <md-divider></md-divider>

    <span class="md-caption">copyright © 2017-{{ new Date().getFullYear() }} Hiroshi Jo</span>

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

h2,
.md-body-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// About.vue?018d5b86